import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Incidental } from '../reservations';

type Variables = { id: number };
type Response = Incidental;

export const useIncidental = createQuery<Response, Variables, AxiosError>({
  queryKey: ['incidentals'],
  fetcher: ({ id }) => {
    return client.get(`v2/incidentals/${id}`).then((response) => {
      return response.data.data;
    });
  },
});
